import { Component } from 'react'

export class TaxonomyTerm extends Component {

	constructor( props ) {
		super( props )

		this.state = {
			toggleClass: props.showList ? 'show-list': 'hide-list',
		}

		this.updateTermValue = this.updateTermValue.bind( this )
		this.toggleListDisplay = this.toggleListDisplay.bind( this )
	}

	toggleListDisplay() {
		let toggleClass = 'show-list' === this.state.toggleClass ? 'hide-list' : 'show-list'

		this.setState({ 
			toggleClass: toggleClass,
		})
	}

	updateTermValue( event ) {
		let termSlug = event.target.getAttribute( 'data-value' )

		if ( event.target.checked ) {
			this.props.addTermToQuery( termSlug, this.props.taxonomyName )
		} else {
			this.props.removeTermFromQuery( termSlug, this.props.taxonomyName )
		}
	}

	ToggleButton() {
		if ( this.props.children ) {
			return (
				<button 
					type="button" 
					className="pf-taxonomy__term-toggle" 
					onClick={ this.toggleListDisplay }
				/>
			)
		}

		return ''
	}

	render() {

		return (
			<li className={ `pf-taxonomy__list-item ${this.state.toggleClass}` }>
				<div className="pf-taxonomy__term-container">
					<label 
						className="pf-taxonomy__list-item-label" 
						htmlFor={ `taxonomy-term-${this.props.term.term_id}` }
					>
						<input 
							className="sr-only pf-taxonomy__input"
							type="checkbox" 
							id={ `taxonomy-term-${this.props.term.term_id}` } 
							data-value={ this.props.term.term_id } 
							onChange={ this.updateTermValue }
							checked={ this.props.isActive }
						/>

						<div className="pf-taxonomy__checkbox"></div>

						<span dangerouslySetInnerHTML={{__html: this.props.term.name }}></span>
					</label>

					{ this.ToggleButton() }
				</div>

				{ this.props.children }
			</li>
		)
	}

}